import { FormType } from '../../../form-types';
import { ECGQuestionFieldAnswers } from '../questions';

const ecgMonitor: FormType<ECGQuestionFieldAnswers> = {
  name: 'ECG Monitor Consultation',
  questions: [
    // Start with sex assigned at birth question
    {
      key: 'ecg_sexAssignedAtBirth',
      next: {
        condition: { 'ecg_sexAssignedAtBirth.female': true },
        key: 'ecg_pregnancyStatus',
        els: 'ecg_medicalConditions'
      }
    },

    // Pregnancy question (conditional for females)
    {
      key: 'ecg_pregnancyStatus',
      next: {
        condition: { 'ecg_pregnancyStatus.yes': true },
        key: 'ecg_ineligible',
        els: 'ecg_medicalConditions'
      }
    },

    // Medical conditions question
    {
      key: 'ecg_medicalConditions',
      next: {
        switch: [
          {
            condition: { 'ecg_medicalConditions.cardiac_condition': true },
            key: 'ecg_conditionDetails'
          },
          {
            condition: { 'ecg_medicalConditions.arrhythmias': true },
            key: 'ecg_conditionDetails'
          },
          {
            condition: { 'ecg_medicalConditions.respiratory_disease': true },
            key: 'ecg_conditionDetails'
          }
        ],
        els: 'ecg_cardiacSymptoms'
      }
    },

    // Condition details (conditional based on medical conditions)
    'ecg_conditionDetails',

    // Cardiac symptoms question
    {
      key: 'ecg_cardiacSymptoms',
      next: {
        condition: { 'ecg_cardiacSymptoms.none': true },
        key: 'ecg_contraindications',
        els: 'ecg_urgentEvaluationConsent'
      }
    },

    // Urgent evaluation consent (conditional based on cardiac symptoms)
    {
      key: 'ecg_urgentEvaluationConsent',
      next: {
        condition: { 'ecg_urgentEvaluationConsent.decline': true },
        key: 'ecg_ineligible',
        els: 'ecg_contraindications'
      }
    },

    // Contraindications question
    {
      key: 'ecg_contraindications',
      next: {
        switch: [
          {
            condition: { 'ecg_contraindications.skin_allergies': true },
            key: 'ecg_ineligible'
          },
          {
            condition: { 'ecg_contraindications.skin_injuries': true },
            key: 'ecg_ineligible'
          },
          {
            condition: { 'ecg_contraindications.implanted_device': true },
            key: 'ecg_ineligible'
          },
          {
            condition: { 'ecg_contraindications.medical_emergency': true },
            key: 'ecg_ineligible'
          }
        ],
        els: 'ecg_additionalQuestions'
      }
    },

    // Additional questions
    'ecg_additionalQuestions',

    // Truthfulness consent
    {
      key: 'ecg_truthfulnessConsent',
      next: {
        condition: { 'ecg_truthfulnessConsent.decline': true },
        key: 'ecg_ineligible',
        els: 'ecg_deviceConsent'
      }
    },

    // Device consent
    {
      key: 'ecg_deviceConsent',
      next: {
        condition: { 'ecg_deviceConsent.decline': true },
        key: 'ecg_ineligible',
        els: 'ecg_complete'
      }
    },

    // Terminal states
    'ecg_complete',
    'ecg_ineligible'
  ]
};
export default ecgMonitor;
